export const RECAPTCHA_FAILED_LOADING =
  'Google reCAPTCHA failed to load. Please refresh the page and try again. If the problem persists contact support.'
export const RECAPTCHA_FAILED_EXECUTING =
  'Google reCAPTCHA failed to execute. Please refresh the page and try again.'
export const RECAPTCHA_HASNT_LOADED =
  "Google reCAPTCHA scripts haven't loaded. Please refresh the page and try again."
export const FRONT_EGG_RECAPTCHA_ERROR_MESSAGE = 'Captcha validation failed. Please try again'
export const OVERWRITTEN_FRONT_EGG_RECAPTCHA_ERROR_MESSAGE =
  'CAPTCHA failed. Please email support@flowcode.com so we can help!'
